module.exports = __webpack_public_path__ + "static/img/female-bg-pt.8b0caca4.png";